// import { createStore } from "redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk"; // import redux-thunk middleware


import rootReducer from "../reducers/index";

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk)
  )
);

export type RootState = ReturnType<typeof store.getState>;

export default store;
